(function () {
  // guide_category renders two sections that both emit this <script src>: same URL, executed twice.
  // Without the lock every arrow click scrolls two slides.
  if (window.__mnlMostRead) return;
  window.__mnlMostRead = true;

  function initOne(root) {
    var track = root.querySelector('[data-mnl-mr-track]');
    if (!track) return;

    var prev = root.querySelector('[data-mnl-mr-prev]');
    var next = root.querySelector('[data-mnl-mr-next]');
    var slide = root.querySelector('[data-mnl-mr-slide]');

    function slideWidth() {
      if (!slide) return 320;
      var rect = slide.getBoundingClientRect();
      // include gap (CSS uses gap: 18px)
      return rect.width + 18;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -slideWidth(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: slideWidth(), behavior: 'smooth' });
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.mnl-mostread').forEach(initOne);
  }

  // Obfuscation: clicks on .mnl-obf decode base64 url from data-u
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.mnl-obf');
    if (!link) return;
    e.preventDefault();
    try {
      var url = atob(link.dataset.u || '');
      if (url) window.location.href = url;
    } catch (err) {}
  });

  document.addEventListener('DOMContentLoaded', initAll);

  // Shopify Theme Editor: re-init when sections reload
  document.addEventListener('shopify:section:load', initAll);
})();
